import { Button, ButtonGroup } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import AddIcon from '@mui/icons-material/Add';
import { IsTenantAdministrator } from 'components/helpers/IsTenantAdministrator';
import TenantPage from 'components/common/TenantPage';
import { requestDepartmentLaboratoryService } from 'services/api';
import { GridColDef } from '@mui/x-data-grid-premium';
import { EnhancedDataGrid } from 'components/common/enhanced/data-grid';
import { RequestLaboratoryTranscodeColumns } from 'components/common/enhanced/common-headers/req-department-transcodes';
import { useRef } from 'react';

export const RequestDepartmentTranscodes = () => {
  const translationPrefix = 'pages.request-dep-lab';
  const datagridRefresh = useRef(null);

  const { t } = useTranslation();

  const columns: GridColDef[] = RequestLaboratoryTranscodeColumns();

  return (
    <>
      <TenantPage
        title={t(`${translationPrefix}.title`)}
        subtitle={t(`${translationPrefix}.subtitle`)}
        menuRight={
          <div className="flex justify-end items-center">
            <ButtonGroup>
              <IsTenantAdministrator>
                <Link to="new">
                  <Button color="primary" size="small">
                    <AddIcon />
                    {t(`${translationPrefix}.add`)}
                  </Button>
                </Link>
              </IsTenantAdministrator>
            </ButtonGroup>
          </div>
        }>
        <div className="mt-6">
          <EnhancedDataGrid
            columns={columns}
            service={requestDepartmentLaboratoryService}
            refresh={datagridRefresh}
          />
        </div>
      </TenantPage>
    </>
  );
};

export default RequestDepartmentTranscodes;
